module.exports = __webpack_public_path__ + "static/media/export-dark.ae548ba7.svg";